<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h2 class="text-h2 mt-5">Icons</h2>
        <v-row>
          <v-col class="d-flex">
            <AcceptIcon/>
            <AcceptIcon color="gray"/>
            <span class="px-1">
              AcceptIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <AddIcon/>
            <AddIcon background-color="gray" color="#57b98f"/>
            <span class="px-1">
              AddIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <AddIconSimple/>
            <AddIconSimple color="#57b98f"/>
            <span class="px-1">
              AddIconSimple
            </span>
          </v-col>
          <v-col class="d-flex">
            <AdminIcon/>
            <AdminIcon color="#57b98f"/>
            <span class="px-1">
              AdminIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <AssignmentIcon/>
            <AssignmentIcon color="gray"/>
            <span class="px-1">
              AssignmentIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <AssignmentRemoveIcon/>
            <AssignmentRemoveIcon color="gray"/>
            <span class="px-1">
              AssignmentRemoveIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <AvailableIcon/>
            <AvailableIcon color="gray"/>
            <span class="px-1">
              AvailableIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <CalendarIcon/>
            <CalendarIcon color="gray"/>
            <span class="px-1">
              CalendarIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <CheckIconLg/>,
            <CheckIconLg color="gray"/>
            <span class="px-1">
              CheckIconLg
            </span>
          </v-col>
          <v-col class="d-flex">
            <CooperationIcon/>
            <CooperationIcon color="#57b98f"/>
            <span class="px-1">
              CooperationIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <CooperationPlusIcon/>
            <CooperationPlusIcon color="#57b98f"/>
            <span class="px-1">
              CooperationPlusIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <DeleteIcon/>
            <DeleteIcon color="gray"/>
            <span class="px-1">
              DeleteIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <DeleteIconLight/>
            <DeleteIconLight color="#57b98f"/>
            <span class="px-1">
              DeleteIconLight
            </span>
          </v-col>
          <v-col class="d-flex">
            <DiscardIcon/>
            <DiscardIcon color="#57b98f"/>
            <span class="px-1">
              DiscardIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <DistributeLeadIcon/>
            <DistributeLeadIcon color="#57b98f"/>
            <span class="px-1">
              DistributeLeadIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <Edit2Icon/>
            <span class="px-1">
              Edit2Icon
            </span>
          </v-col>
          <v-col class="d-flex">
            <EditIcon/>
            <span class="px-1">
              EditIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <EllipseIcon/>
            <span class="px-1">
              EllipseIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <EntryIcon/>
            <span class="px-1">
              EntryIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <FindIcon/>
            <span class="px-1">
              FindIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <GroupIcon/>
            <span class="px-1">
              GroupIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <HamburgerIcon/>
            <span class="px-1">
              HamburgerIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <HamburgerIconDark/>
            <span class="px-1">
              HamburgerIconDark
            </span>
          </v-col>
          <v-col class="d-flex">
            <InfoIcon/>
            <span class="px-1">
              InfoIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <InIcon/>
            <span class="px-1">
              InIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <InvitationIcon/>
            <span class="px-1">
              InvitationIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadGiverIcon/>
            <span class="px-1">
              LeadGiverIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadTakerAvatarIcon/>
            <span class="px-1">
              LeadTakerAvatarIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadTakerIcon/>
            <span class="px-1">
              LeadTakerIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadtributorCloudIcon/>
            <span class="px-1">
              LeadtributorCloudIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadtributorCloudIconColor/>
            <span class="px-1">
              LeadtributorCloudIconColor
            </span>
          </v-col>
          <v-col class="d-flex">
            <LeadtributorSimple/>
            <span class="px-1">
              LeadtributorSimple
            </span>
          </v-col>
          <v-col class="d-flex">
            <LockClosedIcon/>
            <span class="px-1">
              LockClosedIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LockOpenIcon/>
            <span class="px-1">
              LockOpenIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <LogOffIcon/>
            <span class="px-1">
              LogOffIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <MailIconLg/>
            <span class="px-1">
              MailIconLg
            </span>
          </v-col>
          <v-col class="d-flex">
            <MarketplaceIcon/>
            <span class="px-1">
              MarketplaceIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <MarketsIcon/>
            <span class="px-1">
              MarketsIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <MinusIcon/>
            <span class="px-1">
              MinusIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <NewLeadIcon/>
            <span class="px-1">
              NewLeadIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <NotoficationIcon/>
            <span class="px-1">
              NotoficationIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <NoTrendIcon/>
            <span class="px-1">
              NoTrendIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <OfferedIcon/>
            <span class="px-1">
              OfferedIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <PersonIcon/>
            <span class="px-1">
              PersonIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <PersonIconDark/>
            <span class="px-1">
              PersonIconDark
            </span>
          </v-col>
          <v-col class="d-flex">
            <PhoneIcon/>
            <span class="px-1">
              PhoneIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <PictureIcon/>
            <span class="px-1">
              PictureIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <PipelineCircleFilledIcon/>
            <span class="px-1">
              PipelineCircleFilledIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <PipelineCircleOutlinedIcon/>
            <span class="px-1">
              PipelineCircleOutlinedIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <QuestionIcon/>
            <span class="px-1">
              QuestionIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <QuestionIconGreen/>
            <span class="px-1">
              QuestionIcon (from icons/QuestionIconGreen)
            </span>
          </v-col>
          <v-col class="d-flex">
            <SettingsIcon/>
            <span class="px-1">
              SettingsIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <SortIndicationIcon/>
            <span class="px-1">
              SortIndicationIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <SponsoringIcon/>
            <span class="px-1">
              SponsoringIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <StopwatchIcon/>
            <span class="px-1">
              StopwatchIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <StrategyIcon/>
            <span class="px-1">
              StrategyIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <TrendDownIcon/>
            <span class="px-1">
              TrendDownIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <TrendUpIcon/>
            <span class="px-1">
              TrendUpIcon
            </span>
          </v-col>
          <v-col class="d-flex">
            <WaitingIndicator/>
            <span class="px-1">
              WaitingIndicator
            </span>
          </v-col>
          <v-col class="d-flex">
            <WarningIcon/>
            <span class="px-1">
              WarningIcon
            </span>
          </v-col>


          <v-col class="d-flex">

            <span class="px-1">

            </span>
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="6">
        <h2 class="text-h2 mt-5">Colors</h2>

        <h2 class="text-h2 mt-5">Form</h2>
        <v-row>

          <v-col cols="12" class="d-flex">
            <span class="color-preview grey--text text--lighten-1 mr-1"></span>
            <span class="color-name px-1">
              Border default
            </span>
            <code class="color-code mx-1">
              css: border-color: map-get($grey, 'lighten-1');
            </code>
          </v-col>

          <v-col cols="12" class="d-flex">
            <span class="color-preview green--text text--darken-1 mr-1"></span>
            <span class="color-name px-1">
              Border Focus
            </span>
            <code class="color-code mx-1">
              css: border-color: map-get($green, 'darken-1');
            </code>
          </v-col>

          <v-col cols="12" class="d-flex">
            <span class="color-preview red--text text--darken-1 mr-1"></span>
            <span class="color-name px-1">
              Error Text
            </span>
            <code class="color-code mx-1">
              css: border-color: map-get($red, 'darken-1');
            </code>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AcceptIcon from "../components/icons/AcceptIcon";
import AddIcon from "../components/icons/AddIcon";
import AddIconSimple from "../components/icons/AddIconSimple";
import AdminIcon from "../components/icons/AdminIcon";
import AssignmentIcon from "../components/icons/AssignmentIcon";
import AssignmentRemoveIcon from "../components/icons/AssignmentRemoveIcon";
import AvailableIcon from "../components/icons/AvailableIcon";
import CalendarIcon from "../components/icons/CalendarIcon";
import CheckIconLg from "../components/icons/CheckIconLg";
import CooperationIcon from "../components/icons/CooperationIcon";
import CooperationPlusIcon from "../components/icons/CooperationPlusIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import DeleteIconLight from "@/components/icons/DeleteIconLight";
import DiscardIcon from "@/components/icons/DiscardIcon";
import DistributeLeadIcon from "@/components/icons/DistributeLeadIcon";
import Edit2Icon from "@/components/icons/Edit2Icon";
import EditIcon from "@/components/icons/EditIcon";
import EllipseIcon from "@/components/icons/EllipseIcon";
import EntryIcon from "@/components/icons/EntryIcon";
import FindIcon from "@/components/icons/FindIcon";
import GroupIcon from "@/components/icons/GroupIcon";
import HamburgerIcon from "@/components/icons/HamburgerIcon";
import HamburgerIconDark from "@/components/icons/HamburgerIconDark";
import InIcon from "@/components/icons/InIcon";
import InvitationIcon from "@/components/icons/InvitationIcon";
import LeadtributorCloudIcon from "@/components/icons/LeadtributorCloudIcon";
import LeadtributorCloudIconColor from "@/components/icons/LeadtributorCloudIconColor";
import LeadtributorSimple from "@/components/icons/LeadtributorSimple";
import LockClosedIcon from "@/components/icons/LockClosedIcon";
import LockOpenIcon from "@/components/icons/LockOpenIcon";
import LogOffIcon from "@/components/icons/LogOffIcon";
import MailIconLg from "@/components/icons/MailIconLg";
import MarketsIcon from "@/components/icons/MarketsIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import NewLeadIcon from "@/components/icons/NewLeadIcon";
import NotoficationIcon from "@/components/icons/NotificationIcon";
import NoTrendIcon from "@/components/icons/NoTrendIcon";
import OfferedIcon from "@/components/icons/OfferedIcon";
import PersonIcon from "@/components/icons/PersonIcon";
import PersonIconDark from "@/components/icons/PersonIconDark";
import PhoneIcon from "@/components/icons/PhoneIcon";
import PictureIcon from "@/components/icons/PictureIcon";
import PipelineCircleFilledIcon from "@/components/icons/PipelineCircleFilledIcon";
import PipelineCircleOutlinedIcon from "@/components/icons/PipelineCircleOutlinedIcon";
import QuestionIcon from "@/components/icons/QuestionIcon";
import QuestionIconGreen from "@/components/icons/QuestionIconGreen";
import SettingsIcon from "@/components/icons/SettingsIcon";
import SortIndicationIcon from "@/components/icons/SortIndicationIcon";
import StopwatchIcon from "@/components/icons/StopwatchIcon";
import StrategyIcon from "@/components/icons/StrategyIcon";
import TrendDownIcon from "@/components/icons/TrendDownIcon";
import TrendUpIcon from "@/components/icons/TrendUpIcon";
import WaitingIndicator from "@/components/icons/WaitingIndicator";
import WarningIcon from "@/components/icons/WarningIcon";
import InfoIcon from "@/components/icons/InfoIcon";
import LeadGiverIcon from "@/components/icons/LeadGiverIcon";
import LeadTakerAvatarIcon from "@/components/icons/LeadTakerAvatarIcon";
import LeadTakerIcon from "@/components/icons/LeadTakerIcon";
import MarketplaceIcon from "@/components/icons/MarketplaceIcon";
import SponsoringIcon from "@/components/icons/SponsoringIcon";

export default {
  name: "IconView",
  components: {
    SponsoringIcon,
    MarketplaceIcon,
    LeadTakerIcon,
    LeadTakerAvatarIcon,
    LeadGiverIcon,
    InfoIcon,
    WarningIcon,
    WaitingIndicator,
    TrendUpIcon,
    TrendDownIcon,
    StrategyIcon,
    StopwatchIcon,
    SortIndicationIcon,
    SettingsIcon,
    QuestionIcon,
    PipelineCircleOutlinedIcon,
    PipelineCircleFilledIcon,
    PictureIcon,
    PhoneIcon,
    PersonIconDark,
    PersonIcon,
    OfferedIcon,
    NoTrendIcon,
    NotoficationIcon,
    NewLeadIcon,
    MinusIcon,
    MarketsIcon,
    MailIconLg,
    LogOffIcon,
    LockOpenIcon,
    LockClosedIcon,
    LeadtributorSimple,
    LeadtributorCloudIconColor,
    LeadtributorCloudIcon,
    InvitationIcon,
    InIcon,
    HamburgerIconDark,
    HamburgerIcon,
    GroupIcon,
    FindIcon,
    EntryIcon,
    EllipseIcon,
    EditIcon,
    Edit2Icon,
    DistributeLeadIcon,
    DiscardIcon,
    DeleteIconLight,
    DeleteIcon,
    CooperationPlusIcon,
    CooperationIcon,
    CheckIconLg,
    CalendarIcon,
    AvailableIcon,
    AssignmentRemoveIcon,
    AssignmentIcon,
    AdminIcon,
    AddIconSimple,
    AddIcon,
    AcceptIcon,
    QuestionIconGreen
  },
  setup() {

  }
}
</script>

<style scoped lang="scss">
.color-preview {
  background-color: currentColor;
  display: inline-block;
  border: 1px solid map-get($grey, 'base');
  width: $spacer*1.5;
  height: $spacer*1.5;
}

.color-name {

}

.color-code {
  background-color: $black;
  color: $white;
  line-height: 16px;
  font-size: 16px;
  padding: 0.4rem;
}
</style>
